// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.valueMoreThanAVG {
  color: lightcoral;
}

.shortTd {
  width: 3px;
}

.paddingTop {
  padding-top: 20px;
}

.myBtn{
  width: 5em;
  outline: none !important;
}


@media (min-width: 991.98px) {
  .myBtn{
    width: 8em;
  }
  .paddingTop {
    padding-top: 5%;
  }
  .paddingTop3 {
    padding-top: 3%;
  }
  .desktopTableHeightEM {
    height: 65vh;
  }

}

@media (max-width: 991.98px) {


  .mobileTableHeightEM {
    height: 70vh;
  }

  .body {
    font-size: 12px;
  }

  .tableNoMargin {
    margin: 0;
  }

  .mobileHide {
    visibility: hidden;
    display: none;
  }

  .mobile{
    margin: 0;
    padding-right: 0;
    padding-left: 0;

    padding-top: 0%;
    padding-bottom: 0%;
  }
  .mobileLeft {
    padding-top: 0%;
    padding-bottom: 0%;
  }

  .mobileRight {
    float: right;
    padding-top: 0%;
    padding-bottom: 0%;
  }


  .tbodyBorder {
    border-bottom-style: hidden;
  }

  .mobileTdShort {
    padding-left: 0%;
    width: 50px;
  }

  .mobileTdShortest {
    width: 20px;
  }
  .mobileTdLong {
    padding-left: 0%;
    width: 200px;
  }
}
.buttonFooter {
  position: fixed;
  left: 0;
  bottom: 0;
  padding-bottom: 1em;
  width: 100%;
  text-align: center;
}

#overlay {
  background: #ffffff;
  color: #666666;
  position: fixed;
  height: 100%;
  width: 100%;
  z-index: 5000;
  top: 0;
  left: 0;
  float: left;
  text-align: center;
  padding-top: 25%;
  opacity: .80;
}
`, "",{"version":3,"sources":["webpack://./src/app/monitor-item/monitor-item.component.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;;AAGA;EACE;IACE,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;;AAEF;;AAEA;;;EAGE;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,SAAS;IACT,gBAAgB;IAChB,eAAe;;IAEf,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;;;EAGA;IACE,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;IAChB,YAAY;EACd;AACF;AACA;EACE,eAAe;EACf,OAAO;EACP,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,MAAM;EACN,OAAO;EACP,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd","sourcesContent":[".valueMoreThanAVG {\n  color: lightcoral;\n}\n\n.shortTd {\n  width: 3px;\n}\n\n.paddingTop {\n  padding-top: 20px;\n}\n\n.myBtn{\n  width: 5em;\n  outline: none !important;\n}\n\n\n@media (min-width: 991.98px) {\n  .myBtn{\n    width: 8em;\n  }\n  .paddingTop {\n    padding-top: 5%;\n  }\n  .paddingTop3 {\n    padding-top: 3%;\n  }\n  .desktopTableHeightEM {\n    height: 65vh;\n  }\n\n}\n\n@media (max-width: 991.98px) {\n\n\n  .mobileTableHeightEM {\n    height: 70vh;\n  }\n\n  .body {\n    font-size: 12px;\n  }\n\n  .tableNoMargin {\n    margin: 0;\n  }\n\n  .mobileHide {\n    visibility: hidden;\n    display: none;\n  }\n\n  .mobile{\n    margin: 0;\n    padding-right: 0;\n    padding-left: 0;\n\n    padding-top: 0%;\n    padding-bottom: 0%;\n  }\n  .mobileLeft {\n    padding-top: 0%;\n    padding-bottom: 0%;\n  }\n\n  .mobileRight {\n    float: right;\n    padding-top: 0%;\n    padding-bottom: 0%;\n  }\n\n\n  .tbodyBorder {\n    border-bottom-style: hidden;\n  }\n\n  .mobileTdShort {\n    padding-left: 0%;\n    width: 50px;\n  }\n\n  .mobileTdShortest {\n    width: 20px;\n  }\n  .mobileTdLong {\n    padding-left: 0%;\n    width: 200px;\n  }\n}\n.buttonFooter {\n  position: fixed;\n  left: 0;\n  bottom: 0;\n  padding-bottom: 1em;\n  width: 100%;\n  text-align: center;\n}\n\n#overlay {\n  background: #ffffff;\n  color: #666666;\n  position: fixed;\n  height: 100%;\n  width: 100%;\n  z-index: 5000;\n  top: 0;\n  left: 0;\n  float: left;\n  text-align: center;\n  padding-top: 25%;\n  opacity: .80;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
